import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { CniFacilityTariffsTable } from "@/features/cni-tariffs/components/CniFacilityTariffsTable"
import { CniTariffsTable } from "@/features/cni-tariffs/components/CniTariffsTable"

export const Route = createFileRoute("/_authed/cni/tariffs")({
  component: CniTariffsPage,
})

function CniTariffsPage() {
  const { t } = useTranslation("cni-tariffs")
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4 shrink-0">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <div className="flex-1 overflow-auto">
        <section>
          <div className="px-6 pt-4 pb-2">
            <h2 className="text-sm font-semibold">{t("catalog.title")}</h2>
            <p className="text-xs text-ok-foreground-muted">{t("catalog.subtitle")}</p>
          </div>
          <CniTariffsTable />
        </section>
        <section className="border-t border-ok-border mt-4">
          <div className="px-6 pt-4 pb-2">
            <h2 className="text-sm font-semibold">{t("assignments.title")}</h2>
            <p className="text-xs text-ok-foreground-muted">{t("assignments.subtitle")}</p>
          </div>
          <CniFacilityTariffsTable />
        </section>
      </div>
    </div>
  )
}
